import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getLocalTime } from '../../services/Utils';
import { AssistantAvatar, UserAvatar } from './Avatar';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ImageLayout from './ImageLayout';

const Message = ({ message, bg }) => {
    return (
        <Grid sx={{
            height: 'fit-content',
            maxWidth: '100%',
            padding: '8px',
            backgroundColor: bg,
            borderRadius: '10px',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            // whiteSpace: 'pre-wrap',
            '&:hover .copy-button': {
                visibility: 'visible',
            },
        }}>
            <Grid
                sx={{
                    '& *': {
                        margin: '5px',
                        fontSize: '16px',
                    },
                    fontWeight: '450',
                    fontFamily: 'arial, sans-serif',
                }}
            >
                {<Markdown rehypePlugins={[remarkGfm]}>{message?.text}</Markdown>}
            </Grid>
            <Grid>
                {message?.images?.length > 0 && <ImageLayout images={message?.images} />}
            </Grid>
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: '#818080',
                }}
            >
                <Typography fontSize={'12px'}>
                    {getLocalTime(message?.timestamp)}
                </Typography>
                <Tooltip title="Copy">
                    <IconButton
                        className='copy-button'
                        sx={{
                            visibility: 'hidden',
                            padding: '2px',
                            '& *': {
                                fontSize: '12px',
                            }
                        }}
                    >
                        <ContentCopyIcon
                            onClick={() => navigator.clipboard.writeText(message?.text)}
                        />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
}

export const AssistantMessage = ({ message }) => {
    return (
        <Grid sx={{
            width: '100%',
            paddingY: '10px',
            height: 'fit-content',
            justifyContent: 'flex-start',
            gap: '5px',
            flexWrap: 'nowrap',
        }} container>
            <AssistantAvatar />
            <Message message={message} bg={'#ffffff'} />
        </Grid>
    );
}

export const UserMessage = ({ message, userName }) => {
    const theme = useTheme();
    return (
        <Grid sx={{
            width: '100%',
            paddingY: '10px',
            height: 'fit-content',
            justifyContent: 'flex-end',
            gap: '5px',
            flexWrap: 'nowrap',
        }} container>
            <Message message={message} bg={theme.palette.primary[100]} />
            <UserAvatar userName={userName} />
        </Grid>
    );
}